var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 51,
    viewBox: "0 0 57 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5 0C31.1667 0 33.8335 1.30751 35.3565 3.92308L55.9272 39.2308C58.975 44.4614 55.1657 51 49.0708 51H7.92921C1.83431 51 -1.97505 44.4614 1.07275 39.2308L21.6435 3.92308C23.1665 1.30751 25.8333 0 28.5 0ZM28.5 3.92308C27.8125 3.92308 26.1033 4.11409 25.0718 5.88462L4.50098 41.1923C3.46941 42.9629 4.15749 44.5254 4.50098 45.1154C4.84446 45.7054 5.86664 47.0769 7.92921 47.0769H49.0708C51.1334 47.0769 52.1555 45.7054 52.499 45.1154C52.8425 44.5254 53.5306 42.9629 52.499 41.1923L31.9282 5.88462C30.8967 4.11405 29.1875 3.92308 28.5 3.92308ZM32.4584 39.6231C32.4584 41.7904 30.6857 43.5462 28.5 43.5462C26.3143 43.5462 24.5416 41.7904 24.5416 39.6231C24.5416 37.4563 26.3143 35.7 28.5 35.7C30.6857 35.7 32.4584 37.4563 32.4584 39.6231ZM32.4584 17.2615C32.4606 18.569 31.4599 23.659 29.4565 32.5321C29.2472 33.5676 27.7529 33.5676 27.5436 32.5321C25.5424 23.6592 24.5418 18.5693 24.5418 17.2615C24.5418 15.3 26.3144 13.3385 28.5001 13.3385C30.6859 13.3385 32.4618 15.3 32.4585 17.2615H32.4584Z",
    fill: "#1EC252"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorGreen);
export default __webpack_public_path__ + "static/media/errorGreen.b709d037.svg";
export { ForwardRef as ReactComponent };